const parseMaintenanceEnv = (envString) => {
  if (!envString || typeof envString !== 'string') return null;

  const parts = envString.split(';');
  if (parts.length !== 2) return null;

  const parsePart = (part, key) => {
    const prefix = `${key}=`;
    if (!part.startsWith(prefix)) return null;
    const value = part.slice(prefix.length);
    const match = value.match(/^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d)(Z)\+(\d+)$/);
    if (!match) return null;
    const date = new Date(match[1] + match[2]);
    const offsetHours = parseInt(match[3], 10);
    return new Date(date.getTime() - offsetHours * 60 * 60 * 1000);
  };

  const start = parsePart(parts[0], 'START');
  const until = parsePart(parts[1], 'UNTIL');

  if (!start || !until) return null;
  if (Number.isNaN(start.getTime()) || Number.isNaN(until.getTime())) return null;

  return { start, until };
};

export default parseMaintenanceEnv;